import { request } from '@umijs/max';

// 查询模板列表
export async function queryBsTemplateService() {
  return request('/bcare/bal/share/bsTemplate').then(
    (res) => res?.bsTemplateDtoList || [],
  );
}

// 查询 balance share 列表
export async function queryBalanceShareListService(params: any) {
  return request('/bcare/bal/share/list', {
    params,
  }).then((res) => {
    if (res?.balShareList?.length) {
      return {
        total: res?.balShareList?.length,
        list: res?.balShareList,
      };
    }
    return {
      total: 0,
      list: [],
    };
  });
}

// 添加 balance share 成员
export async function addBalShareMemberService(data: any) {
  return request('/bcare/bal/share/add', {
    method: 'POST',
    data,
  });
}
// 删除 balance share 成员
export async function deleteBalShareMemberService(data: any) {
  return request('/bcare/bal/share/del', {
    method: 'POST',
    data,
  });
}

// 修改 balance share 成员
export async function modBalShareMemberService(data: any) {
  return request('/bcare/bal/share/mod', {
    method: 'POST',
    data,
  });
}

// 查询Account Resorce
export async function queryAccountResourceService() {
  return request('/bcare/bal/share/allAcctRes');
}

// 查询单位接口
export async function queryAllUnitTypeService(data: any) {
  return request('/bcare/bal/share/qryUnitList', {
    method: 'POST',
    data,
  }).then((res) => res?.unitList || []);
}
